module.exports = __webpack_public_path__ + "img/Two in One.49fc5939.png";